// Styles for OffersHero go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { mediaQuery } from '../../utils/styles';
import { DOC_DIR } from './utils/enums/enums';

export const StyledOffersHero = styled.div``;

export const StyledOffersHeroPreviewMode = styled.div.attrs({
  className: 'offers-hero-preview-mode',
})`
  pointer-events: none;

  .click-event-enabled {
    pointer-events: auto;
  }
`;

// Styles for single prop hero
export const StyledOffersHeroSingleProperty = styled.div`
  .hero-img-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
    background-color: ${baseVariables.color.neutral00};
    .hero-img-container {
      width: 100%;
      height: ${toRem(359)};
      @media ${mediaQuery.tablet} {
        height: ${toRem(256)};
      }
      @media ${mediaQuery.desktop} {
        height: ${toRem(480)};
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .container {
      padding: 0;
    }
    @media (min-width: 819px) {
      .container {
        margin-left: 0.3rem;
      }
    }
    @media (min-width: 767px) and (max-width: 799px) {
      .container {
        margin-left: 0rem;
      }
    }
    @media ${mediaQuery.mobileOnly} {
      .container {
        padding: 0;
      }
    }
    @media ${mediaQuery.mobile} {
      .container {
        padding: 0rem 0rem;
      }
    }
    .left-section-wrapper {
      @media ${mediaQuery.desktop} {
        max-width: ${toRem(1140)};
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        transition: all 1s;
        padding: 0 ${toRem(8)};
      }
      .hero-left-section {
        position: absolute;
        z-index: 1;
        bottom: ${toRem(105)};
        color: ${baseVariables.color.base20};
        margin-left: ${toRem(16)};
        top: auto;
        @media ${mediaQuery.tablet} {
          bottom: 0;
          width: ${toRem(344)};
          margin-left: ${toRem(42)};
          top: ${toRem(56)};
        }
        @media ${mediaQuery.desktop} {
          top: ${toRem(145)};
          width: ${toRem(551)};
          margin-left: 0;
          bottom: auto;
        }
        @media (min-width: 1023px) and (max-width: 1099px) {
          margin-left: 2.5rem;
        }
        @media (min-width: 799px) and (max-width: 818px) {
          margin-left: 0;
        }
        @media ${mediaQuery.mobileOnly} {
          width: ${toRem(332)};
          margin-left: 0;
        }
        @media ${mediaQuery.mobile} {
          margin-left: 1rem;
        }
        h2 {
          letter-spacing: 0;
          margin-bottom: ${toRem(8)};
          color: ${baseVariables.color.base20};
          text-shadow: 0 0 ${toRem(2)} ${baseVariables.color.neutral00};
        }
        h2:is(:lang(hi-IN)) {
          line-height: ${toRem(48)};
          @media ${mediaQuery.desktop} {
            line-height: ${toRem(56)};
          }
        }
        .m-details-page-teaser {
          font-family: ${baseVariables.font.fontFamilyPl};
          font-size: ${toRem(14)};
          letter-spacing: 0;
          line-height: ${toRem(20)};
          text-shadow: 0 0 ${toRem(2)} ${baseVariables.color.neutral00};
          @media ${mediaQuery.tablet} {
            font-size: ${toRem(16)};
            line-height: ${toRem(24)};
          }
          p {
            margin-top: 0;
            margin-bottom: 0;
          }
        }
        .m-primary-btn-wrapper {
          margin-top: ${toRem(24)};
          .hero-img-button {
            background: ${baseVariables.color.alert10};
            color: ${baseVariables.color.merch30};
            &:active {
              box-shadow: inset ${toRem(9999)} ${toRem(9999)} rgba(28, 28, 28, 0.2);
              border-color: rgba(28, 28, 28, 0.2);
            }
            &:hover {
              @media ${mediaQuery.desktop} {
                box-shadow: inset ${toRem(9999)} ${toRem(9999)} rgba(28, 28, 28, 0.2);
                border-color: rgba(28, 28, 28, 0.2);
              }
            }
          }
        }
      }
      .t-color-white {
        color: ${baseVariables.color.alert10};
      }
      .t-font-brand-style {
        font-family: var(--t-font-family);
      }
      .t-font-brand-style {
        font-family: var(--t-font-family);
      }
    }
    .hero-img-gradient {
      position: absolute;
      height: 100%;
      width: 65%;
      left: 0;
      top: 0;
      background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 55.04%, rgba(0, 0, 0, 0.62) 100%);
      @media ${mediaQuery.mobileOnly} {
        width: 100%;
        height: ${toRem(359)};
      }
    }
  }
`;

// Styles for multi prop hero
export const OffersHeroMultiPropertyStyled = styled.div`
  .section-wrapper {
    @media ${mediaQuery.desktop} {
      min-height: ${toRem(715)};
    }

    display: flex;
    img {
      height: 100%;
      object-fit: cover;
    }
    @media ${mediaQuery.mobileOnly} {
      flex-direction: column;
    }
    @media ${mediaQuery.tabletOnly} {
      min-height: ${toRem(336)};
    }
    .image-section {
      width: 62%;
      position: relative;
      @media ${mediaQuery.tabletOnly} {
        width: 54%;
      }
      @media ${mediaQuery.mobileOnly} {
        width: 100%;
        height: ${toRem(291)};
        img {
          height: ${toRem(291)};
        }
      }
    }

    .details-section {
      width: 38%;
      padding-bottom: ${toRem(0)};
      @media ${mediaQuery.tabletOnly} {
        width: 46%;
      }
      @media ${mediaQuery.mobileOnly} {
        width: 100%;
        min-height: ${toRem(291)};
      }

      .details.mpo {
        .t-brand-logo-s [class*='brand-logo-']:before {
          font-size: 2.041rem !important;
        }
      }

      .details {
        padding: ${toRem(244)} ${toRem(48)} ${toRem(65)};
        top: 50%;
        position: relative;
        transform: translateY(-50%);
        padding-top: 0px;
        .logo.t-brand-logo-s {
          margin-bottom: ${toRem(24)};
          .brand-logo-WH:before {
            font-size: ${toRem(26)};
          }
        }
        @media ${mediaQuery.tabletOnly} {
          padding: ${toRem(96)} ${toRem(32)} ${toRem(55)};
          .logo.t-brand-logo-s {
            margin-bottom: ${toRem(12)};
          }
        }
        @media ${mediaQuery.mobileOnly} {
          padding: ${toRem(66)} ${toRem(40)} ${toRem(45)};
          transform: none;
          .logo.t-brand-logo-s {
            margin-bottom: ${toRem(10)};
          }
        }
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
          text-align: center;
          margin-bottom: ${toRem(8)};
        }

        .desc {
          margin-bottom: ${toRem(22)};
          text-align: center;
          p {
            font-family: ${baseVariables.font.fontFamilyPl};
            font-size: ${toRem(16)};
            letter-spacing: 0;
            line-height: ${toRem(24)};
            text-align: center;
            margin: 0;
          }
        }
        @media ${mediaQuery.mobileTablet} {
          .desc {
            p {
              font-size: ${toRem(14)};
              letter-spacing: 0;
              line-height: ${toRem(20)};
            }
          }
        }

        .navigation-btns {
          &.mpo-sbo-button {
            button:focus {
              outline: 2px solid transparent;
            }
            button:focus-visible {
              outline: auto;
            }
          }
          margin-top: ${toRem(8)};
          a.m-button-primary {
            border: none;
            height: ${toRem(40)};
            border-radius: ${toRem(20)};
            padding: ${toRem(8.34)} ${toRem(25.67)} ${toRem(12.34)} !important;
            text-decoration: none;
            font-family: ${baseVariables.font.fontFamilyPl};
            &:hover {
              border: none;
            }
            &:focus-visible {
              outline: auto;
            }
          }
          a {
            font-size: ${toRem(16)};
            font-weight: 500;
          }

          @media ${mediaQuery.tabletOnly} {
            a.m-button-primary {
              font-size: ${toRem(13)};
              line-height: ${toRem(16)};
              font-weight: 500;
              height: ${toRem(32)};
            }
          }
        }
      }

      &.multi-brand-multi-property-offer {
        background-color: ${baseVariables.color.merch50};
        .details {
          padding-top: ${toRem(273)};
          @media ${mediaQuery.tabletOnly} {
            padding-top: ${toRem(104)};
          }
          @media ${mediaQuery.mobileOnly} {
            padding-top: ${toRem(83)};
          }
          .title {
            .mpo-hero-title {
              font-size: 2.5rem;
            }
            .t-title-m {
              color: ${baseVariables.color.merch30};
            }
          }
          .desc p {
            color: ${baseVariables.color.merch30};
          }

          .navigation-btns {
            a.m-button-primary {
              background-color: ${baseVariables.color.merch30};
              color: ${baseVariables.color.merch50};
              @media ${mediaQuery.mobileOnly} {
                font-size: ${toRem(13)};
                line-height: ${toRem(16)};
                height: ${toRem(32)};
              }

              &:hover {
                background-color: ${baseVariables.color.merch30};
                color: ${baseVariables.color.merch50};
              }
            }
            button:focus-visible {
              outline: 2px auto black;
              box-shadow: inset 0 0 0 2px white;
            }
          }
        }
      }
    }
    img {
      width: 100%;
    }
  }

  .cobrand-single-offer-wrapper {
    &.section-wrapper {
      @media ${mediaQuery.desktop} {
        min-height: ${toRem(553)};
      }
    }
    @media ${mediaQuery.allTablets} {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .cobrand-single-offer {
      @media ${mediaQuery.allTablets} {
        width: 100%;
      }
      .details {
        top: 55%;
        @media ${mediaQuery.allTablets} {
          padding: ${toRem(32)};
          top: unset;
          position: static;
          transform: none;
        }
        @media ${mediaQuery.mobile} {
          padding: ${toRem(32)};
        }
      }
    }
    .image-section {
      @media ${mediaQuery.desktop} {
        height: ${toRem(553)};
      }
      @media ${mediaQuery.allTablets} {
        width: 100%;
        height: ${toRem(432)};
        img {
          height: ${toRem(432)};
        }
      }
      @media ${mediaQuery.mobile} {
        height: ${toRem(211)};
        img {
          height: ${toRem(211)};
        }
      }
    }
  }
`;

const standardGradientRTL =
  'linear-gradient(270deg, rgba(255, 255, 255, 0.54) 0%, rgba(255, 255, 255, 0.46) 79%, rgba(255, 255, 255, 0) 96%);';
const nonStandardGradientRTL =
  'linear-gradient(270deg, rgba(0, 0, 0, 0.62) 0%, rgba(0, 0, 0, 0.54) 76%, rgba(0, 0, 0, 0) 100%);';

// Styles for MBE hero
export const StyledOffersHeroMBE = styled.div<{ scrimGradient: string }>`
  display: flex;
  .hero_item {
    position: relative;
    overflow: hidden;
    .feature-img {
      width: 100vw;
    }
    .gradient {
      &:after {
        @media ${baseVariables.mediaQuery.sm} {
          height: 100%;
          background: ${props =>
            props?.scrimGradient?.includes('standard')
              ? props.dir === DOC_DIR.RTL
                ? standardGradientRTL // hard coded value will be replaced once its added to the global styles
                : `${baseVariables.gradient['baseGradient09']}`
              : props.dir === DOC_DIR.RTL
              ? nonStandardGradientRTL // hard coded value will be replaced once its added to the global styles
              : `${baseVariables.gradient['baseGradient11']}`};
        }
        display: block;
        width: 60%;
        position: absolute;
        content: '';
        bottom: 0;
        left: 0;
        right: 0;
      }
    }
  }
  .hero {
    &__cnt-sec {
      position: absolute;
      display: flex;
      align-items: end;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      &:before {
        display: none;
      }
      .hero_eyebrow_content {
        .isIconOverlay,
        .isImageOverlay {
          margin-bottom: ${toRem(16)};
          @media ${baseVariables.mediaQuery.md} {
            margin-bottom: ${toRem(12)};
          }
          @media ${baseVariables.mediaQuery.lg} {
            margin-bottom: ${toRem(16)};
          }
          .logooverlay-img {
            max-width: ${toRem(150)};
            @media ${baseVariables.mediaQuery.lg} {
              max-width: ${toRem(200)};
            }
          }
        }
        .isIconOverlay {
          .icon_size {
            &:hover {
              background: transparent;
            }
            &::before {
              line-height: 1.25;
              font-size: ${toRem(56)};
              @media ${baseVariables.mediaQuery.lg} {
                font-size: ${toRem(64)};
              }
            }
            &.brand {
              &-logo-RZ::before {
                font-size: ${toRem(57.28)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(71.68)};
                }
              }
              &-logo-EB::before {
                font-size: ${toRem(22.08)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(27.52)};
                }
              }
              &-logo-JW::before {
                font-size: ${toRem(47.36)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(59.2)};
                }
              }
              &-logo-AK::before {
                font-size: ${toRem(49.92)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(62.72)};
                }
              }
              &-logo-BR::before {
                font-size: ${toRem(63.04)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(78.56)};
                }
              }
              &-logo-GE::before {
                font-size: ${toRem(57.6)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(72.8)};
                }
              }
              &-logo-CY::before {
                font-size: ${toRem(18.56)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(23.2)};
                }
              }
              &-logo-RI::before {
                font-size: ${toRem(21.6)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(27.04)};
                }
              }
              &-logo-SH::before {
                font-size: ${toRem(44.8)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(56.32)};
                }
              }
              &-logo-FI::before {
                font-size: ${toRem(33.76)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(42.24)};
                }
              }
              &-logo-TS::before {
                font-size: ${toRem(40.32)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(50.24)};
                }
              }
              &-logo-PR::before {
                font-size: ${toRem(52.48)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(65.44)};
                }
              }
              &-logo-OX::before {
                font-size: ${toRem(40.64)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(50.88)};
                }
              }
              &-logo-LC::before {
                font-size: ${toRem(65.6)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(81.92)};
                }
              }
              &-logo-WI::before {
                font-size: ${toRem(26.88)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(33.44)};
                }
              }
              &-logo-SI::before {
                font-size: ${toRem(56.32)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(70.4)};
                }
              }
              &-logo-MD::before {
                @include brand-icons-resize(17.6, 22.08);
                font-size: ${toRem(17.6)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(22.08)};
                }
              }
              &-logo-TX::before {
                font-size: ${toRem(24.8)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(31.04)};
                }
              }
              &-logo-DS::before {
                font-size: ${toRem(12.4)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(15.5)};
                }
              }
              &-logo-BG::before {
                font-size: ${toRem(27.76)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(34.72)};
                }
              }
              &-logo-AL::before {
                font-size: ${toRem(56)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(70.08)};
                }
              }
              &-logo-HV::before {
                font-size: ${toRem(52)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(64.96)};
                }
              }
              &-logo-WV::before {
                font-size: ${toRem(40)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(48)};
                }
              }
              &-logo-MG::before {
                font-size: ${toRem(40)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(48)};
                }
              }
              &-logo-WH::before {
                font-size: ${toRem(12.48)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(18.56)};
                }
              }
              &-logo-RS::before {
                font-size: ${toRem(32)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(48)};
                }
              }
              &-logo-SN::before {
                font-size: ${toRem(64)};
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: ${toRem(96)};
                }
              }
              &-logo-Escape {
                &::before {
                  font-size: unset;
                  line-height: unset;
                }
                font-size: 4.22rem;
                margin-left: -1.4rem;
                @media ${baseVariables.mediaQuery.lg} {
                  font-size: 5.275rem;
                  margin-left: -1.5rem;
                }
              }
            }
          }
        }
      }
      .hero_content {
        .hero_head {
          margin-bottom: ${toRem(0)};
        }
        @media ${baseVariables.mediaQuery.xl} {
          .hero_head {
            margin-bottom: ${toRem(4)};
          }
        }
      }
      .hero_cta-wrapper {
        display: flex;
        flex-direction: row;
        margin-top: ${toRem(4)};
        text-align: center;
        @media ${baseVariables.mediaQuery.sm} {
          margin-top: -${toRem(8)};
        }
        @media ${baseVariables.mediaQuery.lg} {
          margin-top: ${toRem(0)};
        }
        .hero_sec-cta {
          margin-left: ${toRem(16)};
        }
      }
      &._cta-center {
        justify-content: center;
      }
      @media ${baseVariables.mediaQuery.sm} {
        align-items: center;
      }
    }
  }
  .hero__cnt-ctr {
    position: relative;
    z-index: 1;
    padding: ${toRem(40)} ${toRem(16)} ${toRem(24)};
    margin: 0 auto;
    background: ${props =>
      props?.scrimGradient?.includes('standard')
        ? `${baseVariables.gradient['baseGradient08']}`
        : `${baseVariables.gradient['baseGradient10']}`};
    @media ${baseVariables.mediaQuery.sm} {
      padding-top: ${toRem(0)};
      background: none !important;
      padding: ${toRem(40)} ${toRem(16)} ${toRem(16)};
    }
  }
  .hero_iconText-wrapper {
    position: absolute;
    padding: ${toRem(3)} ${toRem(8)};
    background-color: rgba(28, 28, 28, ${baseVariables.opacity['opacity5']});
    border-radius: ${toRem(5)};
  }
  .hero_16x9 {
    .hero__cnt-ctr {
      padding: ${toRem(40)} ${toRem(16)} ${toRem(40)};
      @media ${baseVariables.mediaQuery.sm} {
        padding-top: ${toRem(0)};
        padding-bottom: ${toRem(0)};
      }
    }
    .hero_iconText-wrapper {
      right: ${toRem(16)};
      bottom: ${toRem(8)};
      @media ${baseVariables.mediaQuery.sm} {
        right: ${toRem(15)};
        bottom: ${toRem(13)};
      }
      @media ${baseVariables.mediaQuery.lg} {
        right: ${toRem(30)};
        bottom: ${toRem(20)};
      }
      @media ${baseVariables.mediaQuery.xl} {
        right: ${toRem(32)};
        bottom: ${toRem(32)};
      }
    }
  }
  .hero_5x2 {
    .hero_iconText-wrapper {
      right: ${toRem(16)};
      top: ${toRem(16)};
      @media ${baseVariables.mediaQuery.sm} {
        right: ${toRem(15)};
        top: ${toRem(13)};
      }
      @media ${baseVariables.mediaQuery.lg} {
        right: ${toRem(30)};
        top: ${toRem(20)};
      }
      @media ${baseVariables.mediaQuery.xl} {
        right: ${toRem(16)};
        top: ${toRem(16)};
      }
    }
  }
  .hero_3x1 {
    .hero__cnt-ctr {
      padding: ${toRem(40)} ${toRem(16)} ${toRem(16)};
      @media ${baseVariables.mediaQuery.sm} {
        padding-top: ${toRem(0)};
        padding-bottom: ${toRem(0)};
      }
    }
    .hero_iconText-wrapper {
      right: ${toRem(16)};
      top: ${toRem(16)};
      @media ${baseVariables.mediaQuery.sm} {
        right: ${toRem(15)};
        top: ${toRem(13)};
      }
      @media ${baseVariables.mediaQuery.lg} {
        right: ${toRem(30)};
        top: ${toRem(20)};
      }
      @media ${baseVariables.mediaQuery.xl} {
        right: ${toRem(16)};
        top: ${toRem(16)};
      }
    }
  }
  .hero-img-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
    background-color: ${baseVariables.color.neutral00};
    .hero-img-container {
      width: 100%;
      height: ${toRem(359)};
      @media ${mediaQuery.tablet} {
        height: ${toRem(256)};
      }
      @media ${mediaQuery.desktop} {
        height: ${toRem(480)};
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .container {
      padding: 0;
    }
    @media (min-width: 819px) {
      .container {
        margin-left: 0.3rem;
      }
    }
    @media (min-width: 767px) and (max-width: 799px) {
      .container {
        margin-left: 0rem;
      }
    }
    @media ${mediaQuery.mobileOnly} {
      .container {
        padding: 0;
      }
    }
    @media ${mediaQuery.mobile} {
      .container {
        padding: 0rem 0rem;
      }
    }
  }
`;
